import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import NumberFormat from "react-number-format";
import {calculateAmount, calculateReward} from "../../../../utils/calculate/Amount";
import {dateDDMMYY} from "../../../../utils/formatters/Date";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {InputText} from "primereact/inputtext";

const UpdateOrderAdmin = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Operación \ Posturas Administrativas \ Actualizar Postura"/>
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Cancelar"
                                    className="p-button-secondary"
                                    onClick={props.handleReturnButton}/>&nbsp;
                            <Button label="Guardar"
                                    onClick={props.updateOrderAdmin}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Prestamista" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.nomCortoPtm}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Prestatario" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.nomCortoPtt}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Cuenta" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.cuenta}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Emisora" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.emision}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Títulos" isBold={true}/>
                                <NumberFormat name="cantidad"
                                              value={props.orderTrade.cantidad}
                                              thousandSeparator={true}
                                              allowNegative={false}
                                              decimalScale={0}
                                              maxLength={17}
                                              onChange={props.saveDataOrderTrade}
                                              placeholder="Ex: 99,99"
                                              customInput={InputText}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Tasa" isBold={true}/>
                                <NumberFormat name="tasa"
                                              value={props.orderTrade.tasa}
                                              allowNegative={false}
                                              decimalScale={2} maxLength={10}
                                              onChange={props.saveDataOrderTrade}
                                              placeholder="Ex: 99,99"
                                              customInput={InputText}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Sobretasa" isBold={true}/>
                                <NumberFormat name="sobreTasa"
                                              value={props.orderTrade.sobreTasa}
                                              decimalScale={2} maxLength={10}
                                              onChange={props.saveDataOrderTrade}
                                              laceholder="Ex: 99,99"
                                              customInput={InputText}
                                              allowNegative={false}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Plazo" isBold={true}/>
                                <NumberFormat name="plazo"
                                              value={props.orderTrade.plazo}
                                              onChange={props.saveDataOrderTrade}
                                              maxLength={4}
                                              decimalScale={0}
                                              allowNegative={false}
                                              fixedDecimalScale={false}
                                              placeholder="Ex: 99,99"
                                              customInput={InputText}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Fecha Valor" isBold={true}/>
                                <SubtitleLabel header={dateDDMMYY(props.orderTrade.fecValor)}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">&nbsp;</div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Precio" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.precio24Hrs}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Importe" isBold={true}/>
                                <SubtitleLabel header={calculateAmount(props.orderTrade.precio24Hrs, props.orderTrade.cantidad)}/>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <SubtitleLabel header="Premio" isBold={true}/>
                                <SubtitleLabel header={calculateReward(
                                    props.orderTrade.cantidad,
                                    props.orderTrade.precio24Hrs,
                                    props.orderTrade.tasa,
                                    props.orderTrade.plazo,)} />
                            </div>
                            <div className="p-col-12">
                                <SubtitleLabel header="Vigencia" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.vigencia === 0 ? 'Diaria' : 'Semanal'}/>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default UpdateOrderAdmin;